<div class="category-bar layout-row space-between">
  <div class="layout-row">
    <div class="tabs layout-row align-middle">
      @for (item of categories; track item.slug) {
        @if (!item.types || item.types.includes('top-bar')) {
          <div class="tab" [class.active]="router.isActive('/' + (item.slug), false)">
            <a *ngIf="item.slug==''; else category" class="btn btn-menu" [href]="root" (click)="navClick(item.name,'category menu desktop')">
              <div class="layout-row align-middle">
                <div class="category-icon small-icon">
                  <img [src]="item.marker" [alt]="item.slug" width="16px" height="16px">
                </div>
                <span class="spacer-left-8">
                  {{item.name}}
                </span>
              </div>
            </a>
            <ng-template #category>
              <a class="btn btn-menu" [href]="'./'+(item.slug)" (click)="navClick(item.name,'category menu desktop')">
                <div class="layout-row align-middle">
                  <div class="category-icon small-icon">
                    <img [src]="item.marker" [alt]="item.slug" width="16px" height="16px">
                  </div>
                  <span class="spacer-left-8">
                    {{item.name}}
                  </span>
                </div>
              </a>
            </ng-template>
          </div>
        }
      }
    </div>
  </div>
  <div class="search-field">
    <gh-search class="full-w"></gh-search>
  </div>

  <div class="align-right layout-row search-more flex-none" (click)="toggleSearch()">
    <div class="spacer-right-8">
      <div *ngIf="isSearchOpened; else more" class="layout-row align-middle">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="#284154" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.00001 5.29285L12.3536 9.6464L11.6465 10.3535L8.00001 6.70706L4.35356 10.3535L3.64645 9.6464L8.00001 5.29285Z" />
        </svg>
      </div>
      <ng-template #more>
        <div class="layout-row align-end">
          <span class="toggle-label spacer-right-8">Stories</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="#284154" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.64642 6.35359L4.35353 5.64648L7.99998 9.29293L11.6464 5.64648L12.3535 6.35359L7.99998 10.7071L3.64642 6.35359Z" />
          </svg>
        </div>
      </ng-template>
    </div>
    <svg width="21" height="22" viewBox="0 0 21 22" fill="#284154" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.87485 1.61572C4.14175 1.61572 1.11548 4.642 1.11548 8.3751C1.11548 12.1082 4.14175 15.1345 7.87485 15.1345C9.43367 15.1345 10.8697 14.6066 12.0132 13.72L18.4278 20.1346H18.7062L19.6343 19.2065V18.9281L13.2197 12.5135C14.1063 11.37 14.6342 9.93394 14.6342 8.3751C14.6342 4.642 11.608 1.61572 7.87485 1.61572ZM2.82173 8.3751C2.82173 5.58433 5.08409 3.32197 7.87485 3.32197C10.6656 3.32197 12.928 5.58433 12.928 8.3751C12.928 11.1659 10.6656 13.4282 7.87485 13.4282C5.08409 13.4282 2.82173 11.1659 2.82173 8.3751Z" />
    </svg>
  </div>

  <div class="search-frame">
    <div class="layout-column">
      <div class="search-field-tablet layout-row">
        <gh-search class="full-w"></gh-search>
        <div class="flex-all"></div>
        <svg (click)="toggleSearch()" width="24" height="24" viewBox="0 0 24 24" fill="#284154" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.9394 12.0001L6.21968 16.7197L7.28034 17.7804L12 13.0607L16.7197 17.7804L17.7803 16.7197L13.0607 12.0001L17.7803 7.28039L16.7197 6.21973L12 10.9394L7.28034 6.21973L6.21968 7.28039L10.9394 12.0001Z" />
        </svg>
      </div>

      @for (item of categories; track item.slug) {
        <div class="category-link" [class.active]="router.isActive('./' + (item.slug), false)">
          <a *ngIf="item.slug==''; else category" class="btn" [href]="root" (click)="navClick(item.slug,'category menu mobile')">
            <div class="layout-row align-middle">
              <div class="category-icon small-icon">
                <img [src]="item.marker" [alt]="item.slug" width="16px" height="16px">
              </div>
              <span class="spacer-left-8">
                {{item.name}}
              </span>
            </div>
          </a>
          <ng-template #category>
            <a class="btn" [href]="'./'+(item.slug)" (click)="navClick(item.slug,'category menu mobile')">
              <div class="layout-row align-middle">
                <div class="category-icon small-icon">
                  <img [src]="item.marker" [alt]="item.slug" width="16px" height="16px">
                </div>
                <span class="spacer-left-8">
                  {{item.name}}
                </span>
              </div>
            </a>
          </ng-template>
        </div>
      }
    </div>
  </div>
</div>
